// Copyright © 2022 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {
  GET_AS_CONFIGURATION_SUCCESS,
  GET_STORED_APPLICATION_UPLINK_MESSAGES,
  GET_STORED_APPLICATION_UPLINK_MESSAGES_COUNT_FAILURE,
  GET_STORED_APPLICATION_UPLINK_MESSAGES_COUNT_SUCCESS,
  GET_STORED_APPLICATION_UPLINK_MESSAGES_FAILURE,
  GET_STORED_APPLICATION_UPLINK_MESSAGES_SUCCESS,
  GET_STORED_DEVICE_UPLINK_MESSAGES,
  GET_STORED_DEVICE_UPLINK_MESSAGES_FAILURE,
  GET_STORED_DEVICE_UPLINK_MESSAGES_SUCCESS,
} from '@console/store/actions/application-server'

const defaultState = {
  configuration: {},
  applicationStoredMessagesLoading: false,
  deviceStoredMessagesLoading: false,
  storedMessages: [],
  appTotalStoredMessages: 0,
}

const applicationServer = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_AS_CONFIGURATION_SUCCESS:
      return {
        ...state,
        configuration: payload.configuration,
      }
    case GET_STORED_APPLICATION_UPLINK_MESSAGES:
      return {
        ...state,
        applicationStoredMessagesLoading: true,
      }
    case GET_STORED_DEVICE_UPLINK_MESSAGES:
      return {
        ...state,
        deviceStoredMessagesLoading: true,
      }
    case GET_STORED_APPLICATION_UPLINK_MESSAGES_SUCCESS:
      return {
        ...state,
        applicationStoredMessagesLoading: false,
        storedMessages: payload,
      }
    case GET_STORED_DEVICE_UPLINK_MESSAGES_SUCCESS:
      return {
        ...state,
        deviceStoredMessagesLoading: false,
        storedMessages: payload,
      }
    case GET_STORED_APPLICATION_UPLINK_MESSAGES_FAILURE:
      return {
        ...state,
        applicationStoredMessagesLoading: false,
      }
    case GET_STORED_DEVICE_UPLINK_MESSAGES_FAILURE:
      return {
        ...state,
        deviceStoredMessagesLoading: false,
      }
    case GET_STORED_APPLICATION_UPLINK_MESSAGES_COUNT_SUCCESS:
      return {
        ...state,
        appTotalStoredMessages: payload,
      }
    case GET_STORED_APPLICATION_UPLINK_MESSAGES_COUNT_FAILURE:
      return {
        ...state,
        appTotalStoredMessages: 0,
      }
    default:
      return state
  }
}

export default applicationServer
